const config = {
  siteName: process.env.REACT_APP_SITE_NAME,
  env: process.env.REACT_APP_ENV,
  prefixPath: process.env.REACT_APP_PREFIX_PATH,
  siteURL: process.env.REACT_APP_SITE_URL,
  wsURL: process.env.REACT_APP_WS_URL,
  publicKey: process.env.REACT_APP_PUBLIC_KEY,
  hcaptchaSiteKey: process.env.REACT_APP_HCAPTCHA_SITEKEY,
  guideImageLightboxViewportRatio: process.env.REACT_APP_GUIDE_IMAGE_LIGHTBOX_VIEWPORT_RATIO,
  landingVariant: process.env.REACT_APP_LANDING_VARIANT || 'legacy',
  landingTheme: process.env.REACT_APP_LANDING_THEME || 'nebula'
};

export default config;
